export default __webpack_public_path__ + "static/media/featured_area_markham.6a4508ee.webp";